<ng-content></ng-content>

<section *ngVar="isLoadingState$ | async as isLoading" id="multiselect-host">
  <div class="content">
    @if (isLoading && isCircleLoader) {
      <app-circle-loader class="circle-loader m-auto h-6 w-6" [appearance]="'dark'"></app-circle-loader>
    }

    <div class="content-container flex justify-between w-full" [class.hidden]="isCircleLoader ? isLoading : false">
      <div class="main-checkmarks" [class.invisible]="isLoading">
        <div class="multiple-selector h-10">
          <app-checkbox
            id="select-checkmark"
            [ngModel]="selectedItemsMap.size"
            [checkBoxVariant]="'multiselect'"
            [checkboxType]="'tertiary'"
            [valueLabel]="
              (selectAllCheckmark ? (buildTranslationKey('selectedCount.all') | translate) : '') +
              (selectedItemsMap.size | i18nPlural: selectedMapping | translate: { count: selectedItemsMap.size })
            "
            [isReadOnly]="isNoneSelected"
            (click)="!isNoneSelected && selectAll(false)"
          ></app-checkbox>
        </div>

        @if (!selectAllCheckmark) {
          <app-new-button
            class="ml-4"
            [size]="'responsive'"
            [type]="'basic'"
            [backgroundMode]="'light'"
            (click)="selectAll(true)"
          >
            <span>{{ buildTranslationKey('selectAll') | translate }}</span>
          </app-new-button>
        }
      </div>

      <div class="buttons gap-2.5">
        @for (button of actionButtons; track $index) {
          <span
            tooltipClass="default-tooltip max-w-55"
            [ngbTooltip]="shouldDisableAdding ? (button.disabledTooltipTranslation | translate) : null"
            [placement]="'top'"
          >
            @if (!button.openableButton) {
              <app-new-button
                class="action-btn"
                [attr.data-test-id]="button.id"
                [disabled]="shouldDisableAdding || !selectedItemsMap.size"
                [size]="'responsive'"
                [type]="button.type || 'secondary'"
                [backgroundMode]="button.backgroundMode || 'light'"
                [ngClass]="button.cssClass || ''"
                [svgIconPath]="button.icon"
                [loading]="actionButtons.length === 1 && isLoading"
                [saveButtonSizeDuringLoading]="button.saveButtonSizeDuringLoading"
                (click)="!isLoading && button.action(selectedItemsMap)"
              >
                <span>{{ buildTranslationKey('buttons.' + button.translationKey) | translate }}</span>
              </app-new-button>
            }
          </span>

          @if (button.openableButton) {
            <app-multiselect-openable-button
              class="openable-button"
              [class.invisible]="isLoading"
              [selectedItems]="getSelectedItemsIds()"
              [openableTemplate]="button.openableTemplate"
              [buttonTranslationKey]="button.translationKey"
              (onLoading)="updateLoadingState($event)"
              (onDone)="selectAll(false)"
              (buttonAction)="button.action(selectedItemsMap)"
            ></app-multiselect-openable-button>
          }
        }

        @if (threeDotsMenu) {
          <app-three-dots-menu
            class="three-dots-menu"
            [class.invisible]="isLoading"
            [dotsType]="'dark'"
            [context]="selectedItemsMap"
            [menuActions]="threeDotsMenu"
            [menuOverlayClass]="'multiselect-mat-menu'"
            [menuText]="menuText"
          ></app-three-dots-menu>
        }
      </div>
    </div>

    @if (!isLoading) {
      <div class="close-section flex flex-row justify-center items-center">
        <span class="bg-navy-40 h-10 mx-2 w-px"></span>
        <app-icon-button
          class="close-button"
          [svgIconPath]="'close-thin'"
          [type]="'basic'"
          (click)="selectAll(false)"
        ></app-icon-button>
      </div>
    }
  </div>
</section>
